import React from "react";
import illustration from "../../resources/Illustration.svg";
import Search from "./Search/Search";
import "./HomeSectionOne.css";

import { Grid } from "@material-ui/core";

function HomeSectionOne() {
  return (
    <div className="homeSectionOne">
      <div className="homeSectionOne__one">
        <div className="homeSectionOne__one--heading">
          <h2>
            The international solution to boost your brand <b>awareness.</b>
          </h2>
        </div>

        <div className="homeSectionOne__one--p">
          <p>
            Collaborate with influential press media and specialized websites in
            your business sector and publish sponsored articles worldwide.{" "}
          </p>
        </div>

        <div className="homeSectionOne__one--search">
          <Search />
        </div>
      </div>

      <div className="homeSectionOne__two">
        <div className="homeSectionOne__two--illustration">
          <img src={illustration} />
        </div>
      </div>
    </div>
  );
}

export default HomeSectionOne;
